import React from 'react';
import './Headings.css';

const RoundedSubHeader = ({ title, text }) => {
    return (
        <div className="headings">
            <h2>{title}</h2>
            <p>{text}</p>
        </div>
    )
}

const HeaderText = ({ title, text }) => {
    return (
        <div className="headings">
            <h1>{title}</h1>
        </div>
    )
}

export { RoundedSubHeader, HeaderText };